import axios from 'axios';
import { ROOT_URL, getAuthHeaders, isUnauthorizedError } from './constants';

export const GET_CENTRO_ESPANOL_COURSES = 'GET_CENTRO_ESPANOL_COURSES';
export const GET_CENTRO_ESPANOL_COURSE = 'GET_CENTRO_ESPANOL_COURSE';
export const CREATE_CENTRO_ESPANOL_COURSE = 'CREATE_CENTRO_ESPANOL_COURSE';
export const UPDATE_CENTRO_ESPANOL_COURSE = 'UPDATE_CENTRO_ESPANOL_COURSE';
export const DISABLE_CENTRO_ESPANOL_COURSE = 'DISABLE_CENTRO_ESPANOL_COURSE';
export const ENABLE_CENTRO_ESPANOL_COURSE = 'ENABLE_CENTRO_ESPANOL_COURSE';

export function getCentroEspanolCourses(pagination = '', successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/centro_espanol_courses${pagination}`, getAuthHeaders());

  return (dispatch) => {
    request.then(({ data }) => {
      dispatch({
        type: GET_CENTRO_ESPANOL_COURSES,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}

export function getCentroEspanolCourse(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/centro_espanol_courses/${id}`, getAuthHeaders());

  return (dispatch) => {
    request.then(({ data }) => {
      dispatch({
        type: GET_CENTRO_ESPANOL_COURSE,
        payload: data
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}

export function createCentroEspanolCourse(courseData, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.post(`${ROOT_URL}/centro_espanol_courses`, {
    centro_espanol_course: courseData
  }, getAuthHeaders());

  return (dispatch) => {
    request.then(({ data }) => {
      dispatch({
        type: CREATE_CENTRO_ESPANOL_COURSE,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}

export function updateCentroEspanolCourse(id, courseData, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/centro_espanol_courses/${id}`, {
    centro_espanol_course: courseData
  }, getAuthHeaders());

  return (dispatch) => {
    request.then(({ data }) => {
      dispatch({
        type: UPDATE_CENTRO_ESPANOL_COURSE,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}

export function disableCentroEspanolCourse(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/centro_espanol_courses/${id}/disable`, {}, getAuthHeaders());

  return (dispatch) => {
    request.then(() => {
      dispatch({
        type: DISABLE_CENTRO_ESPANOL_COURSE,
        payload: id
      });
      successCallback();
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}

export function enableCentroEspanolCourse(id, successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.patch(`${ROOT_URL}/centro_espanol_courses/${id}/enable`, {}, getAuthHeaders());

  return (dispatch) => {
    request.then(({ data }) => {
      dispatch({
        type: ENABLE_CENTRO_ESPANOL_COURSE,
        payload: data
      });
      successCallback(data);
    }).catch((error) => {
      if (!isUnauthorizedError(error, dispatch)) {
        errorCallback(error);
      }
    });
  };
}
